import * as React from 'react';
import MeetNowCommandButton from '../MeetNowCommandButton';

const styles = require('./MeetNowVariants.scss');

export default function MeetNowSuiteHeaderButton() {
    return (
        <MeetNowCommandButton
            rootStyles={styles.meetNowButtonContainer}
            iconStyles={styles.meetNowColorStyles}
            labelStyles={styles.meetNowColorStyles}
            scenario={'SuiteHeader'}
        />
    );
}
